// ZARELLE LONDON theme scripts
document.addEventListener('click', function (event) {
  var burger = event.target.closest('[data-menu-toggle]');
  if (burger) {
    var panel = document.querySelector('[data-mobile-menu]');
    if (panel) panel.classList.toggle('is-open');
  }
});

// Product variant selection
(function () {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var variants = JSON.parse(form.getAttribute('data-variants') || '[]');
  var idInput = form.querySelector('[name="id"]');
  var priceEl = document.querySelector('[data-product-price]');
  var submit = form.querySelector('[data-add-button]');

  function selected() {
    return Array.prototype.map.call(
      form.querySelectorAll('[data-option-group]'),
      function (group) {
        var active = group.querySelector('.swatch.is-active');
        return active ? active.getAttribute('data-value') : null;
      }
    );
  }

  function update() {
    var chosen = selected();
    var match = variants.filter(function (variant) {
      return chosen.every(function (value, index) {
        return value === null || variant.options[index] === value;
      });
    })[0];

    if (!match) return;
    if (idInput) idInput.value = match.id;
    if (priceEl) priceEl.textContent = match.price;
    if (submit) {
      submit.disabled = !match.available;
      submit.textContent = match.available ? 'Add to Cart' : 'Sold Out';
    }
  }

  form.addEventListener('click', function (event) {
    var swatch = event.target.closest('.swatch');
    if (!swatch || swatch.disabled) return;
    event.preventDefault();
    var group = swatch.closest('[data-option-group]');
    group.querySelectorAll('.swatch').forEach(function (item) {
      item.classList.remove('is-active');
    });
    swatch.classList.add('is-active');
    update();
  });

  update();
})();
